var _path, _path2, _path3, _path4, _path5;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBuildingIcon = function SvgBuildingIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 0H5.6C5.22881 0.000441231 4.87293 0.176178 4.61046 0.488643C4.34799 0.801108 4.20037 1.22477 4.2 1.66667V5H1.4C1.02881 5.00044 0.672931 5.17618 0.41046 5.48864C0.147989 5.80111 0.000370634 6.22477 0 6.66667V15H14V1.66667C13.9996 1.22477 13.852 0.801108 13.5895 0.488643C13.3271 0.176178 12.9712 0.000441231 12.6 0ZM1.4 13.3333V6.66667H4.2V13.3333H1.4ZM12.6 13.3333H5.6V1.66667H12.6V13.3333Z",
    fill: "#9997A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.33333H8.4V6.66667H7V3.33333Z",
    fill: "#9997A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 3.33333H11.2V6.66667H9.8V3.33333Z",
    fill: "#9997A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.33333H8.4V11.6667H7V8.33333Z",
    fill: "#9997A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 8.33333H11.2V11.6667H9.8V8.33333Z",
    fill: "#9997A0"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBuildingIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/building_icon.e2f5a0f7.svg";
export { ForwardRef as ReactComponent };